import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link as LinkComponent } from 'react-router-dom'
import styled from 'styled-components'

import { logIn } from 'actions'
import {
  logInErrorSelector,
  logInEmailErrorSelector,
  logInPasswordErrorSelector,
  hasRedirectSelector,
  isAuthenticatedSelector,
} from 'selectors'
import { header5, body } from 'styles/texts'
import { primary } from 'styles/colors'

import { Form, Field, Input, FormContainer } from 'components/form'
import ButtonComponent from 'components/Button'
import Error from 'components/Error'

const FormWrapper = styled(FormContainer)`
  margin: auto;
`

const Button = styled(ButtonComponent)`
  margin-top: 10px;
  width: 186px;
  align-self: center;
`

const Links = styled.div`
  align-self: stretch;
  display: flex;
  justify-content: space-between;
`

const Link = styled(LinkComponent)`
  ${header5};
  margin-top: 30px;
  align-self: center;
  color: ${primary};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

const Heading = styled.div`
  margin: 30px 0 10px;
  font-size: 42px;
  color: white;
  text-align: center;
`

const Text = styled.div`
  margin: 10px 0 30px;
  ${body};
  font-size: 17px;
  color: white;
  text-align: center;
`

class LogIn extends React.Component {
  state = {
    email: this.props.email,
    password: '',
  }

  componentDidMount() {
    document.body.style.backgroundColor = '#5F4B76'
  }

  componentWillUnmount() {
    document.body.style.backgroundColor = ''
  }

  logIn = e => {
    e.preventDefault()
    this.props.logIn(this.state.email, this.state.password)
  }

  render() {
    const { from } = this.props.location.state || { from: { pathname: '/' } }

    if (this.props.isAuthenticated) {
      return <Redirect to={from} />
    }

    return (
      <React.Fragment>
        {this.props.hasRedirect && (
          <div>
            <Heading>To sek.</Heading>
            <Text>Du må logge inn for å se denne siden.</Text>
          </div>
        )}
        <FormWrapper small title="Logg inn">
          <Form onSubmit={this.logIn}>
            {this.props.error && <Error>{this.props.error}</Error>}
            <Field>
              <Input
                placeholder="E-post"
                id="email"
                type="email"
                value={this.state.email}
                onChange={e => this.setState({ email: e.target.value })}
                error={this.props.emailError}
                autoFocus={!this.props.passwordError}
                required
              />
            </Field>
            <Field>
              <Input
                placeholder="Passord"
                id="password"
                type="password"
                value={this.state.password}
                onChange={e => this.setState({ password: e.target.value })}
                error={this.props.passwordError}
                autoFocus={this.props.passwordError}
                required
              />
            </Field>
            <Button size="large" type="submit">
              Logg inn
            </Button>
            <Links>
              <Link to="/register">Registrer deg</Link>
              <Link to="/resetPassword">Glemt passord?</Link>
            </Links>
          </Form>
        </FormWrapper>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, props) => ({
  email: state.auth.email || '',
  error: logInErrorSelector(state),
  emailError: logInEmailErrorSelector(state),
  passwordError: logInPasswordErrorSelector(state),
  hasRedirect: hasRedirectSelector(state, props),
  isAuthenticated: isAuthenticatedSelector(state),
})

const mapDispatchToProps = { logIn }

export default connect(mapStateToProps, mapDispatchToProps)(LogIn)



// WEBPACK FOOTER //
// ./src/pages/LogIn.js